import EventPublisher from "../utils/EventPublisher";


class BaseStore {

    constructor(storeUpdateEvent, stateBuilderClass) {
        this.storeUpdateEvent = storeUpdateEvent;
        this.stateBuilderClass = stateBuilderClass;
        this.state = new stateBuilderClass().build();
    }

    subscribeToEvent(event, callback) {
        EventPublisher.subscribe(event, (topic, data) => {
            const res = callback(topic, data);
            this.compareAndUpdate(res);
        });
    }

    resetStore = (topic, data) => {
        return new this.stateBuilderClass().build();
    };

    compareAndUpdate(newState) {
        if (!this.state.equals(newState)) {
            this.setState(newState);
            EventPublisher.publish(this.storeUpdateEvent, this.getState());
        }
    }

    setState(newState) {
        this.state = newState;
    }

    getState() {
        return this.state;
    }

}
export default BaseStore;